// extracted by mini-css-extract-plugin
export default {"button":"Button_button__r6L25","full":"Button_full__XaE1W"};